import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth, getLandingPath } from '../lib/auth';
import { Loader2 } from 'lucide-react';

/**
 * Handles Emergent Google Auth callback.
 * Detects #session_id in URL hash, exchanges with backend, redirects to dashboard or login.
 */
const AuthCallback = () => {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    exchangeGoogleSession(sessionId).then(result => {
      // Clean the hash regardless of outcome
      window.history.replaceState({}, document.title, window.location.pathname);
      if (result.success) {
        // result.user populated by exchangeGoogleSession when available
        const u = result.user || JSON.parse(localStorage.getItem('user') || '{}');
        navigate(getLandingPath(u), { replace: true });
      } else {
        navigate(`/login?error=${encodeURIComponent(result.error || 'Authentication failed')}`, { replace: true });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50" data-testid="auth-callback">
      <Loader2 className="h-10 w-10 text-teal-600 animate-spin mb-4" />
      <p className="text-slate-600 font-medium">Completing sign in...</p>
      <p className="text-xs text-slate-400 mt-1">Verifying your Google account</p>
    </div>
  );
};

export default AuthCallback;
